module.exports = __webpack_public_path__ + "static/media/cheque_fr.207b2864.png";